import  React,{memo,Fragment, useState, useEffect} from 'react'

//react-bootstrap
import {  Form, Button, Modal } from 'react-bootstrap'
import dayjs from 'dayjs';
//router
import { Link } from 'react-router-dom'
import Card from '../../../components/bootstrap/card'
import { Select, DatePicker, message, Button as AntButton } from 'antd'
import {isEmpty, isString } from 'lodash'
import { getAllGroupsService } from '../../../services/UserService';


const toEmailList = (emails) => {
    if(isEmpty(emails)){
        return []
    }
    if(isString(emails)){
        return emails.split(',')
    }
    return emails
 }

const transformUserDetails = (userData) =>{ 
    let d = {
        ...userData,
        bcc : toEmailList(userData.bcc),
        cc :toEmailList(userData.cc),
        email_to : toEmailList(userData.email_to),
        document_links : userData.document_links || []
    }

    return d



  }


const AdminEdit = memo( (props) => {
    const [userData, setUserData] = useState(transformUserDetails(props.userData));
    const [userDetails, setUserDetails] = useState({
        role: localStorage.getItem('role'),
        iec: localStorage.getItem('iec_no'),
        name: localStorage.getItem('name'),
        group_id: localStorage.getItem('group_id'),
        group_head: localStorage.getItem('group_head')
    })
   const [groupOptions, setGroupOptions] = useState([]);
   const [loadingGroups, setLoadingGroups] = useState(false);
   const [currentLinkType, setCurrentLinkType] = useState('');
   const [currentLinkUrl, setCurrentLinkUrl] = useState('');
   const linkTypeOptions = [
      { label: 'D2D Exp. Docs', value: 'D2D Exp. Docs' },
      { label: 'D2D Imp. Docs', value: 'D2D Imp. Docs' },
      { label: 'D2D Courier BE. Docs', value: 'D2D Courier BE. Docs' },
      { label: 'e-BRC' , value: 'e-BRC'},
      { label: 'Other Docs' , value: 'Other Docs'}
   ]   

   // show only specific editable inputs when editing superadmin 
   const mode = props.mode || "admin-edit";
   const isSuperAdminEdit = mode === "superadmin-edit";

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        
        setUserData((prevData) => ({
            ...prevData,
            [id]: value,
        }));
      };

    
   const handleUpdateUser = async () => {
      try {
         if (userData.data_visible_from_dt && userData.data_visible_to_dt) {
            const fromDate = dayjs(userData.data_visible_from_dt);
            const toDate = dayjs(userData.data_visible_to_dt);

            if (toDate.isBefore(fromDate)) {
               message.error('To-Date cannot be before From-Date');
               return; // Stop execution
            }
         }
         props.handleUpdate(userData)
      } catch (error) {
         console.error('Error updating user:', error);
      }
    };

    const fetchGroups = async () => {
        setLoadingGroups(true);
        try {
            const token = localStorage.getItem('token');
            const response = await getAllGroupsService(token);
            if (response && response.data) {
                const options = response.data.map((group) => ({
                    label: group.name,
                    value: group.id,
                }));
                setGroupOptions(options);
            }
        } catch (error) {
            console.error('Error fetching groups:', error);
        } finally {
            setLoadingGroups(false);
        }
    };

    useEffect(() => {
        fetchGroups();
    }, []);

    console.log("data recieved", userData)

   const handleFromDateChange = (date, dateString) => {
      setUserData((prevData) => ({
         ...prevData,
         data_visible_from_dt: date ? dateString : null,
      }));
   };

   const handleToDateChange = (date, dateString) => {
      setUserData((prevData) => ({
         ...prevData,
         data_visible_to_dt: date ? dateString : null,
      }));
   };


   const validateEmails = (emailList = []) => {
    const uniqueEmails = []
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    for (let i of emailList) {
       if (!uniqueEmails.includes(i) && emailRegex.test(i)) {
          uniqueEmails.push(i)
       }
    }
    return uniqueEmails
 }

 const handleAddDocumentLink = () => {
   if (!currentLinkType || !currentLinkUrl) return;
   
   setUserData((prev) => {
      const updatedLinks = [...(prev.document_links || [])];
      const existingIndex = updatedLinks.findIndex((link) => link.type === currentLinkType);
      
      if (existingIndex >= 0) {
         updatedLinks[existingIndex] = { type: currentLinkType, link: currentLinkUrl };
      } else {
         updatedLinks.push({ type: currentLinkType, link: currentLinkUrl });
      }
      
      return {
         ...prev,
         document_links: updatedLinks,
      };
   });
   
   // Clear fields
   setCurrentLinkType('');
   setCurrentLinkUrl('');
};

const handleRemoveDocumentLink = (indexToRemove) => {
   setUserData((prev) => ({
      ...prev,
      document_links: prev.document_links.filter((_, index) => index !== indexToRemove),
   }));
};
  
 

    return (
        <Fragment>
            <Modal show={props.show} onHide={props.handleClose} backdrop="static">
                <Modal.Body>
                <Card>
                     <Card.Header className="d-flex justify-content-between">
                        <div className="header-title">
                           <h4 className="card-title">Edit User Information</h4>
                        </div>
                     </Card.Header>
                     <Card.Body>
                        <div className="new-user-info">
                           <Form>
                              <div className="row">
                                    <Form.Group className="col-md-6 form-group">
                                        <Form.Label htmlFor="fullname">Full Name:</Form.Label>
                                        <Form.Control type="text" value={userData.fullname} id="fullname" placeholder="Full Name"  onChange={handleInputChange}/>
                                    </Form.Group>
                                    <Form.Group className="col-md-6  form-group">
                                        <Form.Label htmlFor="mobile">Mobile Number:</Form.Label>
                                        <Form.Control type="text" value={userData.mobile} id="mobile" placeholder="Mobile Number" onChange={handleInputChange}/>
                                    </Form.Group>

                                {!isSuperAdminEdit && (
                                 <>
                                    <hr />
                                    <Form.Group className="col-md-12 form-group">
                                       <Form.Label htmlFor="iec_no">IEC:</Form.Label>
                                       <Form.Control
                                       type="text"
                                       id="iec_no"
                                       value={userData.iec_no}
                                       placeholder="IEC"
                                       disabled={!(userDetails.role === 'superadmin' || userDetails.role === 'group_head')}
                                       onChange={(userDetails.role === 'superadmin' || userDetails.role === 'group_head') ? handleInputChange : undefined}
                                       />
                                    </Form.Group>
                                 </>
                                 )}

                                 {userDetails.role === 'superadmin' && !isSuperAdminEdit && (
                                    <>
                                       <Form.Group className="col-md-6 form-group">
                                          <Form.Label>Data Access From:</Form.Label>
                                          <DatePicker 
                                             style={{ width: '100%' }}
                                             placeholder="Start Date"
                                             onChange={handleFromDateChange}
                                             value={userData.data_visible_from_dt ? dayjs(userData.data_visible_from_dt) : null}
                                             getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                          />
                                       </Form.Group>
                                       <Form.Group className="col-md-6 form-group">
                                          <Form.Label>Data Access To</Form.Label>
                                          <DatePicker 
                                             style={{ width: '100%' }}
                                             placeholder="End Date"
                                             onChange={handleToDateChange}
                                             value={userData.data_visible_to_dt ? dayjs(userData.data_visible_to_dt) : null}
                                             allowClear
                                             getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                          />
                                       </Form.Group>
                                    </>
                                 )}

                                 {userDetails.role === 'superadmin' &&  !isSuperAdminEdit && (
                                 <>
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label>Select Link Type</Form.Label>
                                    <Select
                                       style={{ width: '100%' }}
                                       value={currentLinkType}
                                       onChange={setCurrentLinkType}
                                       options={linkTypeOptions}
                                       placeholder="Select type"
                                       getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    />
                                 </Form.Group>
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label>Link URL</Form.Label>
                                    <div className="d-flex align-items-end gap-2">
                                       <Form.Control
                                          type="text"
                                          placeholder="Enter link URL"
                                          value={currentLinkUrl}
                                          onChange={(e) => setCurrentLinkUrl(e.target.value)}
                                          className="flex-grow-1"
                                       />
                                       <Button
                                          type="button"
                                          variant="primary"
                                          style={{ whiteSpace: 'nowrap', height: '36px' }}
                                          onClick={handleAddDocumentLink}
                                          disabled={!currentLinkType || !currentLinkUrl}
                                       >
                                          Add
                                       </Button>
                                    </div>
                                 </Form.Group>

                                 {userData.document_links && userData.document_links.length > 0 && (
                                    <div className="col-md-12 mb-3">
                                       <div className="d-flex flex-wrap gap-2">
                                          {userData.document_links.map((doc, index) => (
                                             <Button
                                                key={index}
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={() => window.open(doc.link, '_blank')}
                                                className="d-flex align-items-center"
                                             >
                                                {doc.type}
                                                <span
                                                   className="ms-2 text-danger"
                                                   onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleRemoveDocumentLink(index);
                                                   }}
                                                >
                                                   ✕
                                                </span>
                                             </Button>
                                          ))}
                                       </div>
                                    </div>
                                 )}
                                 </>
                                 )}
                                 <hr />
                                 <Form.Group className="col-md-12  form-group">
                                    <Form.Label htmlFor="email">Email:</Form.Label>
                                    <Form.Control type="email" value={userData.email} id="email" placeholder="Email" onChange={handleInputChange}/>
                                 </Form.Group>
                                 {!isSuperAdminEdit && userDetails.role === 'superadmin' && (
                                    <Form.Group className="col-md-12 form-group">
                                       <Form.Label>Select Group:</Form.Label>
                                       <Select
                                          style={{ width: '100%' }}
                                          placeholder="Select a group"
                                          showSearch
                                          allowClear
                                          optionFilterProp="label"
                                          filterOption={(input, option) =>
                                             (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                          }
                                          value={userData.group_id}
                                          onChange={(val) => {
                                             setUserData(prev => ({ ...prev, group_id: val, group_head: val ? prev.group_head : 0 }));
                                          }}
                                          options={groupOptions}
                                          loading={loadingGroups}
                                          getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                       />
                                       {userData.group_id && (
                                          <Form.Check className="form-check mt-2">
                                             <Form.Check.Input type="checkbox" id="group_head" checked={userData.group_head === 1}
                                                onChange={(e) => {
                                                   const isChecked = e.target.checked;
                                                   setUserData(prev => ({ ...prev, group_head: isChecked ? 1 : 0 }));
                                                }}
                                             />
                                             <Form.Check.Label htmlFor="group_head" className="ms-2">Is group_head</Form.Check.Label>
                                          </Form.Check>
                                       )}
                                    </Form.Group>
                                 )}
                                 { !isSuperAdminEdit && (
                                    <>
                                 <Form.Group className="col-md-12  form-group">
                                    <Form.Label htmlFor="email-to">To Email:</Form.Label>
                                    <Select
                                             mode="tags"
                                             allowClear
                                             dropdownStyle={{ display: 'none' }}
                                             style={{
                                                width: '100%',
                                             }}
                                             placeholder="Please enter email"
                                             defaultValue={[]}
                                             value={toEmailList(userData?.email_to)}
                                             onChange={(e) => {
                                                setUserData((prevData) => ({
                                                   ...prevData,
                                                   'email_to': validateEmails(e),
                                                }));

                                             }}
                                             //maxTagCount='responsive'
                                             options={[]}
                                          />
                                 </Form.Group>

                                 <Form.Group className="col-md-12  form-group">
                                    <Form.Label htmlFor="cc">Cc:</Form.Label>
                                    <Select
                                             mode="tags"
                                             allowClear
                                             dropdownStyle={{ display: 'none' }}
                                             style={{
                                                width: '100%',
                                             }}
                                             placeholder="Please enter cc email"
                                             defaultValue={[]}
                                             value={toEmailList(userData?.cc)}
                                             onChange={(e) => {
                                                setUserData((prevData) => ({
                                                   ...prevData,
                                                   'cc': validateEmails(e),
                                                }));

                                             }}
                                             //maxTagCount='responsive'
                                             options={[]}
                                          />
                                 </Form.Group>

                                 <Form.Group className="col-md-12  form-group">
                                    <Form.Label htmlFor="bcc">Bcc:</Form.Label>
                                    <Select
                                             mode="tags"
                                             allowClear
                                             dropdownStyle={{ display: 'none' }}
                                             style={{
                                                width: '100%',
                                             }}
                                             placeholder="Please enter bcc email"
                                             defaultValue={[]}
                                             value={toEmailList(userData?.bcc)}
                                             onChange={(e) => {
                                                setUserData((prevData) => ({
                                                   ...prevData,
                                                   'bcc': validateEmails(e),
                                                }));

                                             }}
                                             //maxTagCount='responsive'
                                             options={[]}
                                          />
                                 </Form.Group>
                                 </>
                                 )}
                                 {userDetails.role === 'superadmin' && (
                                 <Form.Group className="col-md-12 form-group">
                                    <Form.Check className="form-check">
                                       <Form.Check.Input type="checkbox" id="multi_factor_check" checked={userData.multi_factor_check}
                                        onChange={(e) => {
                                          const { id, checked } = e.target;
                                          setUserData((prev) => ({
                                             ...prev,
                                             [id]: checked,
                                          }));
                                          }}
                                        />
                                       <Form.Check.Label htmlFor="multi_factor_check" className="ms-2">Multi-Factor Authentication</Form.Check.Label>
                                    </Form.Check>
                                 </Form.Group>
                                 )}
                              </div>
                              <hr/>
                              {/* <h5 className="mb-3">Security</h5>
                              <div className="row">
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="pass">Password:</Form.Label>
                                    <Form.Control type="password"  id="password" placeholder="Password" onChange={handleInputChange}/>
                                 </Form.Group>
                                 <Form.Group className="col-md-6 form-group">
                                    <Form.Label htmlFor="repeatpassword">Repeat Password:</Form.Label>
                                    <Form.Control type="password"  id="repeatpassword" placeholder="Repeat Password " onChange={handleInputChange}/>
                                 </Form.Group>
                              </div> */}
                              <Button type="button" variant="btn btn-secondary" onClick={props.handleClose}>Cancel</Button>
                              <Button style={{float: "right"}} type="button" variant="btn btn-primary" onClick={handleUpdateUser}>{(userDetails.role == 'superadmin' || userDetails.role == 'group_head') ? 'Update Admin' : 'Update User'}</Button>
                           </Form>
                        </div>
                     </Card.Body>
                  </Card>
                </Modal.Body>
            </Modal>
        </Fragment>
    )
})

AdminEdit.displayName="AdminEdit"
export default AdminEdit